/**
 * Created by tong on 2018/2/1.
 */
import React from 'react';
class CreditChange extends React.Component {
	render() {
		return (
            <div>
				{this.props.children}
            </div>
		)
	}
}
export default CreditChange;


// WEBPACK FOOTER //
// ./src/routes/creditChange/index.js